module.exports = __webpack_public_path__ + "static/media/Roboto-BlackItalic.9898b99d.woff";